import { BrowserRouter, Route, Routes} from "react-router-dom";
import { useEffect } from "react";
import loadDictionary from "./plugins/locale/load-dictionary";
import LanguageHelper from './plugins/locale/language-helper.js';
import Layout from "./view/Layout";
import PaymentOrderMainPage from "./view/payment_order/PaymentOrderMainPage";
import PartyMainPage from "./view/party/PartyMainPage";
import BankAccountMainPage from "./view/bank_account/BankAccountMainPage";
import LoginPage from "./view/auth/LoginPage";
import BonCardListPage from "./view/bank_account/bon_card/BonCardListPage";
import Dashboard from "./view/Dashboard";
import UserMainPage from "./view/user/UserMainPage";
import RoleMainPage from "./view/role/RoleMainPage";
import BankAccountTransactionsPage from "./view/bank_account/BankAccountTransactionsPage";
import BonCardTransactionsPage from "./view/bank_account/bon_card/BonCardTransactionsPage";
import Forbidden from "./view/Forbidden";
import BonCardReceiptsPage from "./view/bank_account/bon_card/BonCardReceiptsPage";
import InboundRequestLogMainPage from "./view/inbound_request_log/InboundRequestLogMainPage.jsx";
import OutboundRequestLogMainPage from "./view/outbound_request_log/OutboundRequestLogMainPage.jsx";
import ApiAppMainPage from "./view/api_app/ApiAppMainPage.jsx";
import BankAccountDiffTransactionsPage from "./view/bank_account/BankAccountDiffTransactionsPage.jsx";
import BankAccountStatementsPage from "./view/bank_account/BankAccountStatementsPage.jsx";

function App() {
  useEffect(() => {
    LanguageHelper.set('fa');
    loadDictionary('global');
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />}></Route>
          <Route path="/users" element={<UserMainPage />} />
          <Route path="/roles" element={<RoleMainPage />} />
          <Route path="/payment-orders" element={<PaymentOrderMainPage />} />
          <Route path="/parties" element={<PartyMainPage />} />
          <Route path="bank-accounts">
            <Route index element={<BankAccountMainPage />} />
            <Route path=":bankAccountId/transactions" element={<BankAccountTransactionsPage />} />
            <Route path=":bankAccountId/diff-transactions" element={<BankAccountDiffTransactionsPage />} />
            <Route path="statements" element={<BankAccountStatementsPage />} />
            <Route path="bon-cards">
              <Route index element={<BonCardListPage />} />
              <Route path=":bankAccountId/transactions" element={<BonCardTransactionsPage />} />
            </Route>
            <Route path="bon-card-receipts" element={<BonCardReceiptsPage />} />
          </Route>
          <Route path="/api-apps" element={<ApiAppMainPage />} />
          <Route path="/inbound-request-logs" element={<InboundRequestLogMainPage />} />
          <Route path="/outbound-request-logs" element={<OutboundRequestLogMainPage />} />
          {/*<Route path="*" element={<NoPage />} /> */}
        </Route>
        <Route path="/forbidden" element={<Forbidden />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App;
